class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;

    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    // Focus restoration is retained; only keyboard input draws the trigger ring.
    document.addEventListener('pointerdown', () => {
      document.documentElement.dataset.kpNavInput = 'pointer';
    }, { passive: true, capture: true });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' || event.key.startsWith('Arrow')) {
        document.documentElement.dataset.kpNavInput = 'keyboard';
      }
    }, true);
    this.domNodes.hamburgerButtons?.addEventListener("click", (e) => {
      if (this.domNodes.hamburgerButtons.classList.contains("active")) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });
    this.domNodes.backDrop?.addEventListener("click", (e) => {
      this.closeMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (!this.open) return;
      if (event.key === 'Escape') { event.preventDefault(); this.closeMenu(); return; }
      if (event.key !== 'Tab') return;
      const items = [...this.domNodes.menuDrawer.querySelectorAll('a[href], button, summary, input, select, [tabindex="0"]')]
        .filter(el => el.getClientRects().length && !el.disabled);
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    document.addEventListener('unmatchMobile', () => { if (this.open) this.closeMenu(); });
    let menuResizeFrame;
    const resizeMenu = () => {
      cancelAnimationFrame(menuResizeFrame);
      menuResizeFrame = requestAnimationFrame(() => this.setMenuHeight());
    };
    window.addEventListener('resize', resizeMenu, { passive: true });
    window.visualViewport?.addEventListener('resize', resizeMenu, { passive: true });
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
      }
    });
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    if (!banner || typeof window.MinimogLibs?.Swiper !== "function") return;
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    if (!sliderContainer || !menuItem) return;
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((item) => {
      const subMenuContainer = item.querySelector(".m-megamenu-mobile");
      const backBtn = item.querySelector(".m-menu-mobile__back-button");

      if (subMenuContainer) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parentNode = e.target.parentNode;
            if (
              e.target.classList.contains("m-menu-mobile__back-button") ||
              parentNode.classList.contains("m-menu-mobile__back-button")
            ) {
              return;
            }

            this.openSubMenu(subMenuContainer, level);
          },
        });
      }

      if (backBtn && subMenuContainer) {
        backBtn.addEventListener("click", (e) => {
          const level = e.currentTarget.dataset.level;
          this.closeSubMenu(subMenuContainer, level);
        });
      }
    });

    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    if (!this.domNodes.menuDrawer || !this.domNodes.hamburgerButtons || !this.domNodes.headerMobile) return;
    if (window.KpOverlayHistory?.open('menu', {
      show: () => this.openMenu(), hide: () => this.closeMenu(), root: this.domNodes.menuDrawer,
    }) === false) return;
    this.setMenuHeight();
    this.domNodes.menuDrawer.inert = false;
    this.domNodes.hamburgerButtons.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.open = true;
    this.domNodes.hamburgerButtons.classList.add('active');
    const focusDrawer = () => {
      if (this.open && !this.domNodes.menuDrawer.contains(document.activeElement)) {
        this.domNodes.menuDrawer?.querySelector('[data-kp-menu-focus]')?.focus({ preventScroll: true });
      }
    };
    requestAnimationFrame(focusDrawer);
    // Mobile browsers can retain trigger focus until the slide-in completes.
    setTimeout(focusDrawer, 280);
  }

  closeMenu() {
    if (!this.domNodes.menuDrawer || !this.domNodes.hamburgerButtons || !this.domNodes.headerMobile) return;
    window.KpOverlayHistory?.closed('menu');
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;

    setTimeout(() => {
      megaMenuMobile.forEach((container) => {
        container.classList.remove("open");
      });
      menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer.classList.remove("open");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
      hamburgerButtons.classList.remove("active");
      // Close search
    }, this.transitionDuration);
    menuDrawer.inert = true;
    hamburgerButtons.setAttribute('aria-expanded', 'false');
    requestAnimationFrame(() => hamburgerButtons.focus({ preventScroll: true }));
    this.open = false;
  }

  openSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    subMenuContainer.classList.add("open");
  }

  closeSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    subMenuContainer.classList.remove("open");
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    if (!menuDrawer || !headerMobile) return;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const panelHeight = Math.max(0, viewportHeight - Math.max(0, offsetBottom));

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }
}
class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      const trigger = menuItem.querySelector('.m-menu__link--main');
      if (menuItem.querySelector('.m-mega-menu') && trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        menuItem.addEventListener('focusin', () => {
          if (!menuItem.classList.contains('kp-menu-dismissed')) {
            trigger.setAttribute('aria-expanded', 'true');
            this.onMenuItemEnter({ target: menuItem }, index);
          }
        });
        menuItem.addEventListener('focusout', (event) => {
          if (!menuItem.contains(event.relatedTarget)) {
            trigger.setAttribute('aria-expanded', 'false');
            menuItem.classList.remove('kp-menu-dismissed');
            this.onMenuItemLeave({ target: menuItem }, index);
          }
        });
        menuItem.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            menuItem.classList.add('kp-menu-dismissed');
            trigger.focus();
            trigger.setAttribute('aria-expanded', 'false');
            this.onMenuItemLeave({ target: menuItem }, index);
          } else if (event.target === trigger && (event.key === 'ArrowDown' || event.key === ' ')) {
            event.preventDefault();
            menuItem.classList.remove('kp-menu-dismissed');
            trigger.setAttribute('aria-expanded', 'true');
            this.onMenuItemEnter({ target: menuItem }, index);
            setTimeout(() => {
              if (document.activeElement === trigger && !menuItem.classList.contains('kp-menu-dismissed')) {
                menuItem.querySelector('.m-mega-menu a')?.focus();
              }
            }, 160);
          }
        });
      }
      menuItem.addEventListener("mouseenter", (evt) => {
        menuItem.classList.remove('kp-menu-dismissed');
        if (menuItem.querySelector('.m-mega-menu')) trigger?.setAttribute('aria-expanded', 'true');
        this.onMenuItemEnter(evt, index);
      });
      menuItem.addEventListener("mouseleave", (evt) => {
        if (!menuItem.contains(document.activeElement)) {
          trigger?.setAttribute('aria-expanded', 'false');
          this.onMenuItemLeave(evt, index);
        }
      });
    });
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.classList.contains("m-menu__item--mega")) return;

    clearTimeout(this.timeoutLeave);
    clearTimeout(this.timeoutEnter);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(target);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;
        this.container && this.container.classList.add(this.classes.active);
        target.closest(".m-menu__item").classList.add("m-menu__item--active");
        // document.documentElement.classList.add("prevent-scroll");
      }, evt.type === "mouseenter" ? 350 : 0);
    });
  };

  onMenuItemLeave = (evt, index) => {
    clearTimeout(this.timeoutEnter);
    this.activeIndex = -1;
    this.lastActiveIndex = index;
    evt.target.closest(".m-menu__item").classList.remove("m-menu__item--active");
    // document.documentElement.classList.remove("prevent-scroll");

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu(evt.target);
    }, 80);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };
}
